import { useAuth0, type Auth0ContextInterface } from "@auth0/auth0-react";

import { useLogin } from "./authConfig";

export type AuthContext = Auth0ContextInterface<Record<string, unknown>>;

export const useAuthClient = (): AuthContext | undefined => {
    if (!useLogin) {
        return undefined;
    }

    return useAuth0<Record<string, unknown>>();
};
